import React from "react";
import { useBranding } from "@/context/BrandingContext";

export function Shield({ size = 40, withText = false, dark = false }) {
  const { branding } = useBranding();
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <div className="rounded-lg bg-white flex items-center justify-center overflow-hidden shrink-0 shadow-sm" style={{ width: size, height: size }}>
        <img src={branding.logo_url} alt={branding.company_name} className="w-full h-full object-contain" />
      </div>
      {withText && (
        <div className="leading-none">
          <div className={`font-display font-extrabold text-lg tracking-tight uppercase ${dark ? "text-navy" : "text-white"}`}>{branding.company_name}</div>
          <div className="font-display text-[10px] tracking-[0.22em] text-brandred font-semibold uppercase">{branding.tagline}</div>
        </div>
      )}
    </div>
  );
}
